import { uid } from "./uid";
import { defaultEditorShape, defaultMonthConfig, defaultConfig, defaultWeekConfig, defaultColors, } from "./consts";
export { uid } from "./uid";
export function normalizeEditor(state) {
    const editorShape = state.editorShape || defaultEditorShape;
    return editorShape.map((field) => {
        if ("options" in field || "colors" in field) {
            field.values = field.options || field.colors;
        }
        if (field.type === "combo" && field.key === "type") {
            field.options = state.calendars;
        }
        field.id = field.id || uid();
        return field;
    });
}
export function normalizeConfig(config) {
    const normalized = {
        ...defaultConfig,
        ...config,
    };
    const { timeRange, timeStep, eventsOverlay, eventHeight, weekStartsOn } = normalized;
    const { week = {}, day = {}, month = {} } = normalized.views;
    normalized.views = [];
    normalized.views.week = { ...week };
    normalized.views.day = { ...day };
    normalized.views.month = { ...month };
    Object.keys(normalized.views).map(view => {
        let defaults = {};
        const viewConfig = normalized.views[view];
        switch (view) {
            case "day":
            case "week":
                defaults = {
                    timeRange,
                    timeStep,
                    eventsOverlay,
                    eventHeight,
                    ...defaultWeekConfig,
                    ...viewConfig,
                    weekStartsOn,
                };
                break;
            case "month":
                defaults = {
                    eventHeight,
                    ...defaultMonthConfig,
                    ...viewConfig,
                    weekStartsOn,
                };
        }
        normalized.views[view] = { cellCss: () => "", ...defaults };
    });
    return normalized;
}
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function normalizeCalendars(calendars, colors = defaultColors) {
    return calendars.map((calendar, i) => {
        return {
            color: colors[i % colors.length],
            id: uid(),
            active: true,
            ...calendar,
        };
    });
}
//# sourceMappingURL=helpers.js.map